import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { YMMDGetApiParameter } from "@store/Types/ApiModels";

export interface YMMDApiParameter extends ApiParameter {
    year?: string;
    make?: string;
    model?: string;
    diameter?: string;
}

const ymmdUrl = "api/v1/rssw/ymmd";
const ymmdAllUrl = "api/v1/rssw/ymmd/all";

export async function getYMMD(parameter: YMMDApiParameter): Promise<YMMDGetApiParameter> {
    const params: YMMDApiParameter = { ...parameter };
    try {
        const ymmdModel = await get<any>(`${ymmdUrl}`, params);
        return {
            result: ymmdModel,
        };
    } catch (error) {
        return {
            result: [],
        };
    }
}

export async function getAllYmmd(parameter: YMMDApiParameter): Promise<YMMDGetApiParameter> {
    const params: YMMDApiParameter = { ...parameter };
    try {
        const ymmdModel = await get<any>(`${ymmdAllUrl}`, params);
        return {
            result: ymmdModel,
        };
    } catch (error) {
        return {
            result: [],
        };
    }
}
